import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";

export const ForgotPassword = styled(Link)(({ theme }) => ({
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: "22px",
  textAlign: "center",
  textDecorationLine: "underline",
  color: theme.palette.colors.BlackBean,
  fontFamily: theme.typography.fontFamily,
}));
